import {
  BonusStrategy,
  BonusType,
  BonusResult,
  ConfettiConfig,
  AmountConstraints,
} from '../interfaces/bonus.interface';

export class BienvenidaBonusStrategy implements BonusStrategy {
  type = BonusType.BIENVENIDA;
  campaignSpecific = false; // Bono genérico reutilizable

  validateAmount(amount: number): boolean {
    return amount >= 5000000;
  }

  calculateBonus(amount: number, termDays: number): BonusResult {
    const terms = this.getTermsAndConditions();
    if (!this.validateAmount(amount)) {
      return {
        isValid: false,
        bonusAmount: 0,
        message: '',
        confettiType: '',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    let bonusAmount = 0;
    if (amount >= 30000000) {
      bonusAmount = 300000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$300.000</b> extra directo a tu cuenta.',
        message_simulador: `Puedes aplicar para un bono de $300.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
        confettiType: 'snow',
        displayAmount: '$300.000',
        bonusTag: '300k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'BIENVENIDA_300K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 10000000) {
      bonusAmount = 100000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$100.000</b> extra directo a tu cuenta.',
        message_simulador: `Puedes aplicar para un bono de $100.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
        confettiType: 'snow',
        displayAmount: '$100.000',
        bonusTag: '100k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'BIENVENIDA_100K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 5000000) {
      bonusAmount = 50000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$50.000</b> extra directo a tu cuenta.',
        message_simulador: `Puedes aplicar para un bono de $50.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
        confettiType: 'snow',
        displayAmount: '$50.000',
        bonusTag: '50k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'BIENVENIDA_50K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    return {
      isValid: false,
      bonusAmount: 0,
      message: '',
      confettiType: '',
      termsAndConditionsUrl: terms.url,
      termsAndConditionsDescription: terms.description,
    };
  }

  getTermsAndConditions(): { url: string; description: string } {
    return {
      url: '/legal/bonos/bono-de-bienvenida',
      description:
        'Para calificar para el bono de bienvenida de MejorCDT, debes ser un cliente nuevo que abre su primer CDT a través de la plataforma, completando exitosamente el registro y la transferencia de tu inversión. Tu CDT debe tener un plazo mínimo de 12 meses y un monto igual o superior a $5,000,000 COP. El bono es un cashback que se deposita directamente en tu cuenta bancaria personal. Su valor depende del monto de tu inversión: $50,000 COP para inversiones entre $5,000,000 y $9,999,999 , $100,000 COP para montos entre $10,000,000 y $29,999,999 , y $300,000 COP si inviertes $30,000,000 o más. Para recibirlo, debes enviar tu certificado bancario una vez que tu CDT esté activo. La titularidad de la cuenta bancaria debe coincidir exactamente con la del titular del CDT , ya que no se realizan transferencias a cuentas de terceros. Las transferencias del bono se procesan los martes y jueves. Este bono es personal, intransferible y no puede combinarse con otras promociones. Además, MejorCDT puede anularlo si detecta actividad fraudulenta.',
    };
  }

  getConfettiConfig(): ConfettiConfig {
    return {
      type: 'snow',
      duration: 4000,
      intensity: 'medium',
    };
  }

  getAmountConstraints(): AmountConstraints {
    return {
      locked: false,
      minAmount: 5000000,
    };
  }
}
